import { useEffect, useState } from "react"
import { usePresignedDownloadUrl } from "./downloadFIle.hook"
import { useMessage } from "hooks/message.hook"
import { useFileModalStore } from "store/modal.store"
import { removeApiVersion } from "helpers/utils.helper"

export const useDocumentPreview = () => {
	const [previewLink, setPreviewLink] = useState<string>()
	const [previewData, setPreviewData] = useState<string | null>(null)
	const [reloadTrigger, setReloadTrigger] = useState(false)

	const { error: errorMessage } = useMessage()
	const { refetch: refetchPreview } = usePresignedDownloadUrl(previewData)
	const { triggerFileModal } = useFileModalStore()

	// Toggle the reloadTrigger state to force re-fetching the presigned URL and reloading the document
	const forceReload = () => {
		setReloadTrigger(!reloadTrigger)
	}

	// Effect for fetching presigned URL and setting it for preview
	useEffect(() => {
		if (previewData) {
			refetchPreview()
				.then((result) => {
					if (result.isSuccess && result.data) {
						const downloadUrl = result.data.download_url
						setPreviewLink(downloadUrl)
						triggerFileModal()
					}
				})
				.catch(() => {
					errorMessage("Something went wrong, please try again later")
				})
		}
	}, [previewData, refetchPreview, triggerFileModal, errorMessage, reloadTrigger])

	// Handles opening file preview
	const previewHandle = (downloadLink: string) => {
		const cleanLink = removeApiVersion(downloadLink)
		// Drop the PREVIOUS document's link first. It survives the modal closing, so opening a second
		// preview in the same page session left the viewer's load effect looking at the old link while
		// the new one was still being fetched — measured: the previously viewed document was loaded and
		// parsed again (from the HTTP cache, so no re-download, but a full re-render) before the
		// intended one replaced it. Clearing it means the effect's `fileLink` guard holds until the
		// real link lands.
		setPreviewLink(undefined)
		setPreviewData(cleanLink)
		forceReload()
	}

	return { previewLink, previewHandle }
}
